/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const owl_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.75 3 11.61.86c.259-.07.531-.07.79 0L20.25 3 12.4 5.144c-.26.07-.535.07-.795 0L3.75 3Zm0 0v3.001m13.5 1.153V3.82m-9.75.204v2.823m1.984 5.64L12 15l2.516-2.515M18 15v2.337a6 6 0 1 1-12 0V15m12.225-3.553a3.133 3.133 0 0 1 3.525 3.076v2.065a5.217 5.217 0 0 1-5.732 5.142M5.657 11.262A3.15 3.15 0 0 0 2.25 14.4v2.1a5.251 5.251 0 0 0 5.732 5.23m.093-11.979h.346m7.15 0h.346m-4.667 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm7.5 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-10.25 0c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Zm7.496 0c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
    />
  </svg>
)
export default owl_medium
